import { useQuery } from 'react-query';
import { useSelector, shallowEqual } from 'react-redux';

import { FEATURE_FLAG } from '../constants/queryDefinition';
import ReducerConstants from '../constants/reducers';

import FeatureFlagService from '../../services/FeatureFlagService';
import { localStorageService } from '../../services/StorageService';

const featureFlagService = FeatureFlagService.get();

const useFeatureFlags = (featureKey?: string) => {
  const auth = useSelector(state => state[ReducerConstants.AUTH], shallowEqual);
  const userId =
    auth?.user?.id || JSON.parse(window.localStorage.getItem('auth'))?.user?.id;

  async function getFeatureFlags() {
    const featureFlagsResponse = await featureFlagService.getFeatureFlags(
      userId
    );
    // TODO: Will be removed in subsequent releases , this is added to clean-up existing local storage state
    localStorageService.removeItem('featureFlags');
    return featureFlagsResponse;
  }

  const featureFlagList = useQuery(FEATURE_FLAG.KEY, getFeatureFlags, {
    enabled: !!userId,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    cacheTime: FEATURE_FLAG.REFETCH_INTERVAL,
    staleTime: FEATURE_FLAG.REFETCH_INTERVAL,
    retry: false
  });

  // If requested for featureKey then pass the specific feature value or return the complete response
  return featureKey
    ? featureFlagList?.data?.featureFlags?.[featureKey]
    : featureFlagList;
};

export default useFeatureFlags;
